import { ProjectMember } from './types';

export const SELF_MEMBER_ID = 'self';

export function memberDisplayName(member: ProjectMember, selfName: string) {
  if (member.id === SELF_MEMBER_ID) return selfName;
  return member.name || member.id;
}

// The member list and the user search can spell the same person with different
// ids (a Keycloak id and a database id), so the email is compared as well.
export function isAlreadyMember(
  members: ProjectMember[],
  user: Pick<ProjectMember, 'id' | 'email'>,
) {
  const email = user.email.trim().toLowerCase();
  return members.some(
    member =>
      member.id === user.id ||
      (email !== '' && member.email.trim().toLowerCase() === email),
  );
}

export function initials(name: string) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');
}

// The id of the project's only Owner, or undefined when there are none or
// several. Demoting or removing that member would leave the project ownerless.
export function soleOwnerId(members: ProjectMember[]) {
  const owners = members.filter(member => member.role === 'Owner');
  return owners.length === 1 ? owners[0].id : undefined;
}
